import Tooltip from 'antd/lib/tooltip'

import 'antd/lib/tooltip/style'

export * from 'antd/lib/tooltip'

export default Tooltip
